export default {
  getterInstitutionConfiguration : (state) => state.institutionConfiguration,
  showStudentCard                : (state) => state.institutionConfiguration?.showStudentCard,
  getterTopicTypes               : (state) => state.topicTypes,
  getterTopicTypesIcons          : (state) => state.topicTypesIcons,
  getterTopicTypesColors         : (state) => state.topicTypesColors,
  getterTopicTypesNames          : (state) => state.topicTypesNames
};
